/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DateInputIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Date Input',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M32 16.909h1.286a.721.721 0 0 0 .714-.727v-1.455a.721.721 0 0 0-.714-.727h-1.531a2.833 2.833 0 0 0-2.021.852L28 17.272l-1.734-2.42A2.833 2.833 0 0 0 24.245 14h-1.531a.721.721 0 0 0-.714.727v1.455a.721.721 0 0 0 .714.728H24l2 3.151v4.849h-3.286a.721.721 0 0 0-.714.727v1.455a.721.721 0 0 0 .714.727H26v2.121l-2 3.151h-1.286a.721.721 0 0 0-.714.728v1.455a.721.721 0 0 0 .714.727h1.531a2.833 2.833 0 0 0 2.021-.852L28 32.728l1.734 2.42a2.833 2.833 0 0 0 2.021.852h1.531a.721.721 0 0 0 .714-.727v-1.455a.721.721 0 0 0-.714-.728H32l-2-3.15v-2.122h3.286a.721.721 0 0 0 .714-.727v-1.455a.721.721 0 0 0-.714-.727H30V20.06Z"
    />
    <path
      d="M34 12h2V7a1 1 0 0 0-1-1h-5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3H12V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h17v-.182A2.717 2.717 0 0 1 20.706 32H4V8h4v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8h14v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8h4Z"
    />
  </svg>`;
};
